import {
  DEFAULT_LONG_DROUGHT_THRESHOLD,
  DROUGHT_ANALYTICS_TARGETS,
} from '../../shared/constants.ts';

export type DroughtTarget = (typeof DROUGHT_ANALYTICS_TARGETS)[number];

export function isDroughtTarget(value: number): value is DroughtTarget {
  return (DROUGHT_ANALYTICS_TARGETS as readonly number[]).includes(value);
}

export function parseDroughtTargetParam(raw: string | null | undefined): DroughtTarget {
  if (!raw) {
    return 2;
  }
  const value = Number(raw.replace(/x$/i, ''));
  return isDroughtTarget(value) ? value : 2;
}

export function parseLongDroughtThresholdParam(raw: string | null | undefined): number {
  if (!raw) {
    return DEFAULT_LONG_DROUGHT_THRESHOLD;
  }
  const value = Number(raw);
  if (!Number.isInteger(value) || value < 1 || value > 10_000_000) {
    return DEFAULT_LONG_DROUGHT_THRESHOLD;
  }
  return value;
}
